"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestWillBeSentEvent = void 0;
const Initiator_1 = require("./Initiator");
const Request_1 = require("./Request");
class RequestWillBeSentEvent {
    constructor({ requestId, documentURL, request, timestamp, type, }) {
        this.requestId = requestId;
        this.loaderId = requestId; // FIXME
        this.documentURL = documentURL;
        this.request = new Request_1.Request({
            url: request.url,
            method: request.method,
            headers: request.headers,
            initialPriority: 'High',
            referrerPolicy: 'origin', // FIXME
        });
        this.timestamp = timestamp; // FIXME
        this.wallTime = timestamp; // FIXME
        this.initiator = new Initiator_1.Initiator({ type: 'other' });
        this.redirectHasExtraInfo = false;
        this.type = type;
    }
}
exports.RequestWillBeSentEvent = RequestWillBeSentEvent;
